function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object"
        )
    );
}

const trapFocusHandlers = {};
const warningTime = 3000

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (
            event.target !== container &&
            event.target !== last &&
            event.target !== first
        )
        return;
        
        document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function() {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function(event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if (
            (event.target === container || event.target === first) &&
            event.shiftKey
        ) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    elementToFocus.focus();
}

function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });

    document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
    });

    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

const serializeForm = form => {
    const obj = {};
    const formData = new FormData(form);
    for (const key of formData.keys()) {
        obj[key] = formData.get(key);
    }

    return JSON.stringify(obj);
};

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
}

function extractContent(string) {
    var div = document.createElement('div');
    div.innerHTML = string;

    return div.textContent || div.innerText;
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
    window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
    return function() {
        return fn.apply(scope, arguments);
    }
};

Shopify.setSelectorByValue = function(selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];

        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function(target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for(var key in params) {
        var hiddenField = document.createElement("input");

        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
    this.countryEl         = document.getElementById(country_domid);
    this.provinceEl        = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

    this.initCountry();
    this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
    initCountry: function() {
        var value = this.countryEl.getAttribute('data-default');
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function() {
        var value = this.provinceEl.getAttribute('data-default');

        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function(e) {
        var opt       = this.countryEl.options[this.countryEl.selectedIndex];
        var raw       = opt.getAttribute('data-provinces');
        var provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);

        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = 'none';
        } else {
            for (var i = 0; i < provinces.length; i++) {
                var opt = document.createElement('option');
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }

            this.provinceContainer.style.display = "";
        }
    },

    clearOptions: function(selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: function(selector, values) {
        for (var i = 0, count = values.length; i < values.length; i++) {
            var opt = document.createElement('option');

            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    }
};

Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal   = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number/100.0).toFixed(precision);

        var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
}

Shopify.getCart = function(callback) {
    $.getJSON('/cart.js', function (cart, textStatus) {
        if ((typeof callback) === 'function') {
            callback(cart);
        } else {
            Shopify.onCartUpdate(cart);
        }
    });
}

Shopify.onCartUpdate = function(cart) {
    alert('There are now ' + cart.item_count + ' items in the cart.');
}

Shopify.changeItem = function(variant_id, quantity, index, callback) {
    getCartUpdate(index, quantity, callback)
}

Shopify.removeItem = function(variant_id, index, callback) {
    getCartUpdate(index, 0, callback)
}

function getCartSectionIdsForUpdate() {
    if (window.halo?.buildCartSectionsList) {
        return window.halo.buildCartSectionsList(
            document.body.classList.contains('template-cart')
                ? {}
                : { sidebar: document.body.classList.contains('cart-sidebar-show') }
        );
    }

    const sectionIds = [];
    const mainCartSectionId = document.getElementById('main-cart-items')?.dataset.id;

    if (document.body.classList.contains('template-cart') && mainCartSectionId) {
        sectionIds.push(mainCartSectionId);
        return sectionIds;
    }

    // 仅在 sidebar 已打开时才请求 sidebar section，避免无关页面/场景多拉 HTML
    if (document.body.classList.contains('cart-sidebar-show')) {
        sectionIds.push('cart-sidebar-content');
    }

    return sectionIds;
}

function getCartUpdate(line, quantity, callback) {
    const sectionIds = getCartSectionIdsForUpdate();
    const payload = {
        line,
        quantity,
        sections_url: window.location.pathname,
    };

    if (sectionIds.length) {
        payload.sections = sectionIds.join(',');
    }

    const body = JSON.stringify(payload);

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
    .then((response) => {
        return response.json();
    })
    .then((state) => {
        if (state.errors) {
            if (window.halo?.setPendingCartUi) {
                window.halo.setPendingCartUi({
                    main: document.body.classList.contains('template-cart'),
                    sidebar: document.body.classList.contains('cart-sidebar-show')
                }, false);
            }
            showWarning('Error : ' + state.errors, warningTime);
            return;
        }

        if ((typeof callback) === 'function') {
            callback(state);
        } else {
            Shopify.onCartUpdate(state);
        }
    })
    .catch((e) => {
        if (window.halo?.setPendingCartUi) {
            window.halo.setPendingCartUi({
                main: document.body.classList.contains('template-cart'),
                sidebar: document.body.classList.contains('cart-sidebar-show')
            }, false);
        }
        console.error(e);
    })
}

Shopify.addItem = function(variant_id, quantity, $target, callback, input = null) {
    var quantity = quantity || 1;
    let dataForm = 'quantity=' + quantity + '&id=' + variant_id;

    if ($target.closest('form')) {
        const $thisForm = $target.closest('form');
        const $properties = $thisForm.find('[name^="properties"]');
        if ($properties.length) $properties.each((index, element) => {dataForm = `${dataForm}&${$(element).attr('name')}=${$(element).val()}`})
    }

    var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: dataForm,
        dataType: 'json',
        success: function(line_item) {
            if ((typeof callback) === 'function') {
                callback(line_item);
            } else {
                Shopify.onItemAdded(line_item);
            }
        },
        error: function(XMLHttpRequest, textStatus) {
            var message = window.cartStrings.addProductOutQuantity2;
            if (input.length > 0) {
                var maxValue = parseInt(input.attr('data-inventory-quantity'));
                message = getInputMessage(maxValue)
                input.val(maxValue)
            } 
            
            Shopify.onError(XMLHttpRequest, textStatus, message);
            if ($target && typeof $target.removeClass === 'function') {
                $target.removeClass('is-loading');
            }
        }
    };
    $.ajax(params);
}

Shopify.onItemAdded = function(line_item) {
    alert(line_item.title + ' was added to your shopping cart.');
}

Shopify.onError = function(XMLHttpRequest, textStatus, message) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
        !!data.description ? showWarning(data.description) : showWarning(data.message + ': ' + message, warningTime);
    } else {
        showWarning('Error : ' + message, warningTime);
    }
}

class MenuDrawer extends HTMLElement {
    constructor() {
        super();
        this.mainDetailsToggle = this.querySelector('details');
        const summaryElements = this.querySelectorAll('summary');
        this.addAccessibilityAttributes(summaryElements);

        if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

        this.addEventListener('keyup', this.onKeyUp.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.bindEvents();
    }

    bindEvents() {
        this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
        this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }

    addAccessibilityAttributes(summaryElements) {
        summaryElements.forEach(element => {
            element.setAttribute('role', 'button');
            element.setAttribute('aria-expanded', false);
            element.setAttribute('aria-controls', element.nextElementSibling.id);
        });
    }

    onKeyUp(event) {
        if(event.code.toUpperCase() !== 'ESCAPE') return;

        const openDetailsElement = event.target.closest('details[open]');
        if(!openDetailsElement) return;

        openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    }

    onSummaryClick(event) {
        const summaryElement = event.currentTarget;
        const detailsElement = summaryElement.parentNode;
        const isOpen = detailsElement.hasAttribute('open');

        if (detailsElement === this.mainDetailsToggle) {
            if(isOpen) event.preventDefault();
            isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
        } else {
            trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

            setTimeout(() => {
                detailsElement.classList.add('menu-opening');
            });
        }
    }

    openMenuDrawer(summaryElement) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });
        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add('overflow-hidden-mobile');
    }

    closeMenuDrawer(event, elementToFocus = false) {
        if (event !== undefined) {
            this.mainDetailsToggle.classList.remove('menu-opening');

            this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
                details.removeAttribute('open');
                details.classList.remove('menu-opening');
            });

            this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
            document.body.classList.remove('overflow-hidden-mobile');
            removeTrapFocus(elementToFocus);
            this.closeAnimation(this.mainDetailsToggle);
        }
    }

    onFocusOut(event) {
        setTimeout(() => {
            if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
        });
    }

    onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest('details');
        this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
        detailsElement.classList.remove('menu-opening');
        removeTrapFocus();
        this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
        let animationStart;

        const handleAnimation = (time) => {
            if (animationStart === undefined) {
                animationStart = time;
            }

            const elapsedTime = time - animationStart;

            if (elapsedTime < 400) {
                window.requestAnimationFrame(handleAnimation);
            } else {
                detailsElement.removeAttribute('open');

                if (detailsElement.closest('details[open]')) {
                    trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
                }
            }
        }

        window.requestAnimationFrame(handleAnimation);
    }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();
    }

    openMenuDrawer(summaryElement) {
        this.header = this.header || document.getElementById('shopify-section-header');
        this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
        document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });

        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add('overflow-hidden-mobile');
    }
}

customElements.define('header-drawer', HeaderDrawer);

class UpdateQuantity extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeCart = false;
        this.changeEvent = new Event('change', { bubbles: true })
        this.querySelectorAll('.btn-quantity').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }
    
    onButtonClick(event) {
        event.preventDefault();
        const $target = event.target
        let el_input = $target.parentElement.querySelector('.quantity');
        const value = Number(el_input.value);
        const inStockNumber = Number(el_input.dataset.inventoryQuantity);
        const buttonAdd = $target.closest('.product-form')?.querySelector('[data-btn-addtocart]');
        let newVal, checkAvailabel = false;

        const policyArray = document.body.matches('.quickshop-popup-show') ? window[`quick_shop_policy_array_${this.input.dataset.product}`] : window[`cart_selling_array_${this.dataset.product}`],
            currentId = document.body.matches('.quickshop-popup-show') ? this.closest('.productView-options').querySelector('[name="id"]').value : this.input.dataset.cartQuantityId,
            thisVariantStatus = policyArray[currentId];

        buttonAdd?.dataset.available == 'false' || buttonAdd?.dataset.available == undefined ? checkAvailabel = true : checkAvailabel = false;

        if ($target.matches('.plus')) newVal = value + 1;
        else if ($target.matches('.minus')) newVal = value - 1;
        else newVal = value;

        if (newVal < 0 ) newVal = 1;

        if (newVal > inStockNumber && checkAvailabel && thisVariantStatus == 'deny') {
            const message = getInputMessage(inStockNumber);
            showWarning(message, warningTime);
            newVal = inStockNumber
        }

        el_input.value = newVal;

        if (typeof this.changeCart  == 'number') {clearTimeout(this.changeCart)};
        const isCartQuantity = el_input.hasAttribute('data-cart-quantity');
        if (isCartQuantity) {
            el_input.dataset.previousQuantity = String(value);
        }
        const debounceMs = isCartQuantity ? 120 : 350;
        this.changeCart = setTimeout(() => {
            if ($target.matches('.btn-quantity')) this.input.dispatchEvent(this.changeEvent);
        }, debounceMs);
    }

    quantityCheckedToBeContinue() {
        const sellingArray = window[`cart_selling_array_${this.dataset.product}`];
        return sellingArray == undefined ? false : sellingArray[this.querySelector('[name="quantity"]').dataset.cartQuantityId] === 'continue'
    }
}

class UpdateQuantityQuickShop extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true })
        this.querySelectorAll('.btn-quantity').forEach(
            (button) => button.addEventListener('click', this.onChangeQuantity.bind(this))
        );
        this.input.addEventListener('change', this.onChangeQuantity.bind(this))
    }
    
    onChangeQuantity(event) {
        event.preventDefault();
        const target = event.target;
        let el_input = target.parentElement.querySelector('.quantity');
        const value = Number(el_input.value);
        const inStockNumber = Number(el_input.dataset.inventoryQuantity);
        const buttonAdd = target.closest('[data-quickshop]').querySelector('[data-btn-addtocart]');
        let newVal;

        if (target.matches('.plus')) newVal = value + 1;
        else if (target.matches('.minus')) newVal = value - 1;
        else newVal = value;

        if (newVal <= 0) newVal = 1;

        if (newVal > inStockNumber && !buttonAdd.matches('.button--pre-untrack')) {
            const message = getInputMessage(inStockNumber);
            showWarning(message, warningTime);
            newVal = inStockNumber
        }
        
        el_input.value = newVal;
        if (target.matches('.btn-quantity')) this.input.dispatchEvent(this.changeEvent);
        const quickshop = this.closest('[data-quickshop]');
        const realQuantityInput = quickshop.querySelector('form input[type="hidden"]');
        realQuantityInput.setAttribute('value', newVal);
    }
}

class ProductScroller extends HTMLElement {
    constructor() {
        super();    
        this.container = this.querySelector('[data-drag-container]');
        this.dragParent = this.querySelector('[data-drag-parent]');

        this.initDragToScroll();
    }

    initDragToScroll() {
        const isOverflowing = (wrapper) => {
            return wrapper.clientWidth < wrapper.scrollWidth
        }
        let containerOverflowing = isOverflowing(this.container)

        if (containerOverflowing) {
            this.dragToScroll(this.container)
            return 
        }
        this.dragToScroll(this.dragParent)
    }   
    
    dragToScroll(slider) {
        let mouseDown = false;
        let start;
        let scrollLeft;
        let inactiveTimeout;

        slider.addEventListener('mousedown', (e) => {
            const target = e.target 

            mouseDown = true;
            start = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });

        slider.addEventListener('mouseup', () => {
            mouseDown = false;

            clearTimeout(inactiveTimeout)
            inactiveTimeout = setTimeout(() => {
                slider.classList.remove('active');
            }, 150)
        });

        slider.addEventListener('mousemove', (e) => {
            if(!mouseDown) return;
            e.preventDefault();

            if (!slider.classList.contains('active')) {
                slider.classList.add('active');
            }

            const x = e.pageX - slider.offsetLeft;
            const walk = (x - start) * 1; 
            slider.scrollLeft = scrollLeft - walk;
        });

        slider.addEventListener('mouseleave', () => {
            mouseDown = false;

            clearTimeout(inactiveTimeout)
            inactiveTimeout = setTimeout(() => {
                slider.classList.remove('active');
            }, 150)
        });
    }
}

class ImageToFlip extends HTMLElement {
    constructor() {
        super() 

        this.imageContainer = this; 
        this.initObserver();
    }   

    initObserver() {
        this.observer = new IntersectionObserver((entries, observer) => {
            const imageRef = entries[0]

            if (imageRef.isIntersecting) {
                imageRef.target.classList.add('show')
                observer.unobserve(imageRef.target)
            }

        }, 
        {
            threshold: 0.4 
        });
        
        this.observer.observe(this.imageContainer);
    }
}

window.addEventListener('load', () => {
    customElements.define('cart-update-quantity', UpdateQuantity);
    customElements.define('quickshop-update-quantity', UpdateQuantityQuickShop);
    customElements.define('product-scroller', ProductScroller);
    // customElements.define('image-to-flip', ImageToFlip);
})

function showWarning(content, time = null) {
    if (window.warningTimeout) {
        clearTimeout(window.warningTimeout);
    }
    const warningPopupContent = document.getElementById('halo-warning-popup').querySelector('[data-halo-warning-content]')
    warningPopupContent.textContent = content
    document.body.classList.add('has-warning')

    if (time) {
        window.warningTimeout = setTimeout(() => {
            document.body.classList.remove('has-warning')
        }, time)
    }
}

function getInputMessage(maxValue) {
    var message = window.cartStrings.addProductOutQuantity.replace('[maxQuantity]', maxValue);
    return message
}

// 全局 Cookie 操作方法
window.CookieUtils = {
    /**
     * 设置 Cookie
     * @param {string} name - Cookie 名称
     * @param {string} value - Cookie 值
     * @param {Object} options - 可选参数
     * @param {string} options.path - 路径
     * @param {string} options.domain - 域名
     * @param {boolean} options.secure - 是否安全
     * @param {string} options.sameSite - SameSite 属性
     */
    set: function(name, value, options = {}) {
        let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
        
        if (options.path) {
            cookieString += `; path=${options.path}`;
        }
        
        if (options.domain) {
            cookieString += `; domain=${options.domain}`;
        }
        
        if (options.secure) {
            cookieString += '; secure';
        }
        
        if (options.sameSite) {
            cookieString += `; samesite=${options.sameSite}`;
        }
        
        document.cookie = cookieString;
    },
    
    /**
     * 获取 Cookie
     * @param {string} name - Cookie 名称
     * @returns {string|null} - Cookie 值，不存在返回 null
     */
    get: function(name) {
        const nameEQ = encodeURIComponent(name) + "=";
        const ca = document.cookie.split(';');
        
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) {
                return decodeURIComponent(c.substring(nameEQ.length, c.length));
            }
        }
        return null;
    },
    
    /**
     * 删除 Cookie
     * @param {string} name - Cookie 名称
     * @param {string} path - 路径（可选）
     * @param {string} domain - 域名（可选）
     */
    remove: function(name, path, domain) {
        let cookieString = `${encodeURIComponent(name)}=; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
        
        if (path) {
            cookieString += `; path=${path}`;
        }
        
        if (domain) {
            cookieString += `; domain=${domain}`;
        }
        
        document.cookie = cookieString;
    },
    
    /**
     * 检查 Cookie 是否存在
     * @param {string} name - Cookie 名称
     * @returns {boolean} - 是否存在
     */
    exists: function(name) {
        return this.get(name) !== null;
    },
    
    /**
     * 获取所有 Cookie
     * @returns {Object} - 所有 Cookie 的键值对
     */
    getAll: function() {
        const cookies = {};
        const ca = document.cookie.split(';');
        
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            const eqPos = c.indexOf('=');
            if (eqPos > 0) {
                const name = decodeURIComponent(c.substring(0, eqPos));
                const value = decodeURIComponent(c.substring(eqPos + 1));
                cookies[name] = value;
            }
        }
        
        return cookies;
    },
    
    /**
     * 清除所有 Cookie
     * @param {string} path - 路径（可选）
     * @param {string} domain - 域名（可选）
     */
    clearAll: function(path, domain) {
        const cookies = this.getAll();
        
        for (const name in cookies) {
            this.remove(name, path, domain);
        }
    }
};

// 全局 HTTP 请求工具
window.HttpUtils = {
    /**
     * 环境配置
     */
    environments: {
        test: 'https://testmembership.creality.com',
        production: 'https://membership.creality.com'
    },
    
    /**
     * 当前环境（默认测试环境）
     */
    currentEnv: 'production',
    
    /**
     * 默认请求配置
     */
    defaultConfig: {
        timeout: 10000, // 10秒超时
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
    },
    
    /**
     * 设置当前环境
     * @param {string} env - 环境名称 ('test' 或 'production')
     */
    setEnvironment: function(env) {
        if (this.environments[env]) {
            this.currentEnv = env;
        } else {
            console.warn('Unknown environment:', env);
        }
    },
    
    /**
     * 获取当前环境的域名
     * @returns {string} - 当前环境的域名
     */
    getBaseUrl: function() {
        return this.environments[this.currentEnv];
    },
    
    /**
     * 构建完整的请求 URL
     * @param {string} url - 请求路径
     * @returns {string} - 完整的请求 URL
     */
    buildUrl: function(url) {
        // 如果 URL 已经是完整的 URL，直接返回
        if (url.startsWith('http://') || url.startsWith('https://')) {
            return url;
        }
        
        // 如果 URL 以 / 开头，直接拼接域名
        if (url.startsWith('/')) {
            return this.getBaseUrl() + url;
        }
        
        // 否则添加 / 后拼接
        return this.getBaseUrl() + '/' + url;
    },
    
    /**
     * 通用 fetch 请求方法
     * @param {string} url - 请求 URL
     * @param {Object} options - 请求选项
     * @returns {Promise} - 返回 Promise
     */
    request: function(url, options = {}) {
        const config = {
            ...this.defaultConfig,
            ...options
        };
        
        // 构建完整的请求 URL
        const fullUrl = this.buildUrl(url);
        
        // 设置超时
        const timeoutPromise = new Promise((_, reject) => {
            setTimeout(() => reject(new Error('Request timeout')), config.timeout);
        });
        
        // 获取认证 Token
        const authToken = window.AuthUtils ? window.AuthUtils.getAccountToken() : null;
        
        // 合并请求配置
        const fetchOptions = {
            method: config.method || 'GET',
            headers: {
                ...this.defaultConfig.headers,
                ...config.headers
            }
        };
        
        // 如果有 Token，自动添加到请求头
        if (authToken) {
            fetchOptions.headers['token'] = `${authToken}`;
        }
        
        // 添加请求体（如果有）
        if (config.body) {
            fetchOptions.body = config.body;
        }
        
        // 执行请求
        const fetchPromise = fetch(fullUrl, fetchOptions)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response;
            })
            .then(response => {
                // 检查响应是否为 JSON 格式
                const contentType = response.headers.get('content-type');
                if (contentType && contentType.includes('application/json')) {
                    return response.json().then(data => {
                        // 检查业务状态码
                        if (data.code === 800) {
                            // Token 失效，处理失效逻辑
                            if (window.AuthUtils) {
                                window.AuthUtils.handleTokenExpired();
                            }
                            throw new Error('Token expired');
                        }
                        // 将解析后的数据重新包装为 Response 对象
                        return {
                            ok: response.ok,
                            status: response.status,
                            headers: response.headers,
                            json: () => Promise.resolve(data),
                            text: () => Promise.resolve(JSON.stringify(data))
                        };
                    });
                }
                return response;
            });
        
        return Promise.race([fetchPromise, timeoutPromise]);
    },
    
    /**
     * GET 请求
     * @param {string} url - 请求 URL
     * @param {Object} params - 查询参数
     * @param {Object} options - 请求选项
     * @returns {Promise} - 返回 Promise
     */
    get: function(url, params = {}, options = {}) {
        // 构建查询字符串
        const queryString = Object.keys(params)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join('&');
        
        const fullUrl = queryString ? `${url}?${queryString}` : url;
        
        return this.request(fullUrl, {
            method: 'GET',
            ...options
        });
    },
    
    /**
     * POST 请求
     * @param {string} url - 请求 URL
     * @param {Object} data - 请求数据
     * @param {Object} options - 请求选项
     * @returns {Promise} - 返回 Promise
     */
    post: function(url, data = {}, options = {}) {
        return this.request(url, {
            method: 'POST',
            body: JSON.stringify(data),
            ...options
        });
    },
    
    /**
     * 获取 JSON 数据
     * @param {string} url - 请求 URL
     * @param {Object} params - 查询参数
     * @param {Object} options - 请求选项
     * @returns {Promise<Object>} - 返回 JSON 数据
     */
    getJson: async function(url, params = {}, options = {}) {
        const response = await this.get(url, params, options);
        return response.json();
    },
    
    /**
     * 发送 JSON 数据
     * @param {string} url - 请求 URL
     * @param {Object} data - 请求数据
     * @param {Object} options - 请求选项
     * @returns {Promise<Object>} - 返回 JSON 数据
     */
    postJson: async function(url, data = {}, options = {}) {
        const response = await this.post(url, data, options);
        return response.json();
    },
    
    /**
     * 获取文本数据
     * @param {string} url - 请求 URL
     * @param {Object} params - 查询参数
     * @param {Object} options - 请求选项
     * @returns {Promise<string>} - 返回文本数据
     */
    getText: async function(url, params = {}, options = {}) {
        const response = await this.get(url, params, options);
        return response.text();
    },
    
    /**
     * 上传文件
     * @param {string} url - 请求 URL
     * @param {FormData} formData - 表单数据
     * @param {Object} options - 请求选项
     * @returns {Promise} - 返回 Promise
     */
    upload: function(url, formData, options = {}) {
        return this.request(url, {
            method: 'POST',
            body: formData,
            headers: {
                // 不设置 Content-Type，让浏览器自动设置
            },
            ...options
        });
    },
    
};

// 全局 LocalStorage 操作方法
window.StorageUtils = {
    /**
     * 设置 LocalStorage 数据
     * @param {string} key - 键名
     * @param {any} value - 值（会自动序列化为 JSON）
     * @returns {boolean} - 是否设置成功
     */
    set: function(key, value) {
        try {
            const serializedValue = JSON.stringify(value);
            localStorage.setItem(key, serializedValue);
            return true;
        } catch (error) {
            console.error('LocalStorage set error:', error);
            return false;
        }
    },
    
    /**
     * 获取 LocalStorage 数据
     * @param {string} key - 键名
     * @param {any} defaultValue - 默认值（当键不存在时返回）
     * @returns {any} - 存储的值或默认值
     */
    get: function(key, defaultValue = null) {
        try {
            const item = localStorage.getItem(key);
            if (item === null) {
                return defaultValue;
            }
            return JSON.parse(item);
        } catch (error) {
            console.error('LocalStorage get error:', error);
            return defaultValue;
        }
    },
    
    /**
     * 删除 LocalStorage 数据
     * @param {string} key - 键名
     * @returns {boolean} - 是否删除成功
     */
    remove: function(key) {
        try {
            localStorage.removeItem(key);
            return true;
        } catch (error) {
            console.error('LocalStorage remove error:', error);
            return false;
        }
    },
    
    /**
     * 检查 LocalStorage 中是否存在指定键
     * @param {string} key - 键名
     * @returns {boolean} - 是否存在
     */
    exists: function(key) {
        return localStorage.getItem(key) !== null;
    },
    
    /**
     * 获取所有 LocalStorage 数据
     * @returns {Object} - 所有存储的键值对
     */
    getAll: function() {
        const data = {};
        try {
            for (let i = 0; i < localStorage.length; i++) {
                const key = localStorage.key(i);
                if (key) {
                    data[key] = this.get(key);
                }
            }
        } catch (error) {
            console.error('LocalStorage getAll error:', error);
        }
        return data;
    },
    
    /**
     * 清除所有 LocalStorage 数据
     * @returns {boolean} - 是否清除成功
     */
    clearAll: function() {
        try {
            localStorage.clear();
            return true;
        } catch (error) {
            console.error('LocalStorage clearAll error:', error);
            return false;
        }
    },
    
    /**
     * 获取 LocalStorage 使用大小（字节）
     * @returns {number} - 使用的大小
     */
    getSize: function() {
        let total = 0;
        try {
            for (let key in localStorage) {
                if (localStorage.hasOwnProperty(key)) {
                    total += localStorage[key].length + key.length;
                }
            }
        } catch (error) {
            console.error('LocalStorage getSize error:', error);
        }
        return total;
    },
    
    /**
     * 设置带过期时间的 LocalStorage 数据
     * @param {string} key - 键名
     * @param {any} value - 值
     * @param {number} expireMinutes - 过期时间（分钟）
     * @returns {boolean} - 是否设置成功
     */
    setWithExpire: function(key, value, expireMinutes) {
        try {
            const expireTime = Date.now() + (expireMinutes * 60 * 1000);
            const data = {
                value: value,
                expire: expireTime
            };
            return this.set(key, data);
        } catch (error) {
            console.error('LocalStorage setWithExpire error:', error);
            return false;
        }
    },
    
    /**
     * 获取带过期时间的 LocalStorage 数据
     * @param {string} key - 键名
     * @param {any} defaultValue - 默认值
     * @returns {any} - 存储的值或默认值
     */
    getWithExpire: function(key, defaultValue = null) {
        try {
            const data = this.get(key);
            if (data === null) {
                return defaultValue;
            }
            
            // 检查是否包含过期时间
            if (typeof data === 'object' && data.hasOwnProperty('expire') && data.hasOwnProperty('value')) {
                if (Date.now() > data.expire) {
                    // 已过期，删除数据
                    this.remove(key);
                    return defaultValue;
                }
                return data.value;
            }
            
            // 兼容没有过期时间的数据
            return data;
        } catch (error) {
            console.error('LocalStorage getWithExpire error:', error);
            return defaultValue;
        }
    }
};

// 用户认证工具类
window.AuthUtils = {
    /**
     * Token 相关的 Cookie 名称
     */
    TOKEN_NAMES: {
        ACCOUNT: 'accountToken',
        MULTI_PASS: 'customerAccessToken'
    },
    
    /**
     * 判断用户是否已登录
     * @returns {boolean} - 是否已登录
     */
    isLoggedIn: function() {
        if (window.StorageUtils) {
            return window.StorageUtils.exists(this.TOKEN_NAMES.ACCOUNT);
        }
        return false;
    },
    
    /**
     * 获取用户认证 Token
     * @returns {string|null} - 用户 Token，未登录返回 null
     */
    getAccountToken: function() {
        if (window.StorageUtils) {
            return window.StorageUtils.get(this.TOKEN_NAMES.ACCOUNT);
        }
        return null;
    },
    
    /**
     * 获取 MultiPass Token
     * @returns {string|null} - MultiPass Token，不存在返回 null
     */
    getMultiPassToken: function() {
        if (window.StorageUtils) {
            return window.StorageUtils.get(this.TOKEN_NAMES.MULTI_PASS);
        }
        return null;
    },
    
    /**
     * 设置用户认证 Token
     * @param {string} token - 认证 Token
     * @param {Object} options - 存储选项（暂时保留兼容性，但不再使用）
     */
    setAccountToken: function(token, options = {}) {
        if (window.StorageUtils) {
            window.StorageUtils.set(this.TOKEN_NAMES.ACCOUNT, token);
        }
    },
    
    /**
     * 设置 MultiPass Token
     * @param {string} token - MultiPass Token
     * @param {Object} options - 存储选项（暂时保留兼容性，但不再使用）
     */
    setMultiPassToken: function(token, options = {}) {
        if (window.StorageUtils) {
            window.StorageUtils.set(this.TOKEN_NAMES.MULTI_PASS, token);
        }
    },
    
    /**
     * 清除所有认证相关的 Token
     */
    clearAllTokens: function() {
        if (window.StorageUtils) {
            window.StorageUtils.remove(this.TOKEN_NAMES.ACCOUNT);
            window.StorageUtils.remove(this.TOKEN_NAMES.MULTI_PASS);
        }
    },
    
    /**
     * 处理 Token 失效
     */
    handleTokenExpired: function() {
        // 清除所有认证相关的 Token
        this.clearAllTokens();
        
        // 登出后跳转到登录页
        window.location.href = '/account/logout?return_to=/account/login';
    },
    
    
    /**
     * 用户登出
     */
    logout: function() {
        // 清除所有 Token
        this.clearAllTokens();
        // 跳转到 Shopify 登出 URL
        window.location.href = '/account/logout';
    }
};

class FadeInComponent extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initObserver();
    }

    initObserver() {
        const handler = (entries, observer) => {
            if (entries[0].isIntersecting) {
                this.classList.add('fade-in');

                observer.unobserve(this);
            }
        }

        const options = {
            threshold: 0.7
        }

        this.observer = new IntersectionObserver(handler, options); 
        this.observer.observe(this);
    }
}

window.addEventListener('load', () => {
    customElements.define('fade-in-component', FadeInComponent);
    this.loadScrolling();
})

window.onscroll = () => {this.loadScrolling()};

function loadScrolling() {
    document.querySelectorAll('[data-scrolling]').forEach(element => {element.dataset.scrolling == 'vertical' ? this.scrollVertical(element) : this.scrollHorizontal(element)})
}

function scrollVertical(element) {
    const $thisItem = element.closest('.special-banner__item') || element,
        top = $thisItem.getBoundingClientRect().top,
        height = $thisItem.getBoundingClientRect().height,
        wdHeight = window.innerHeight,
        coefficient = element.scrollHeight/height,
        redundant = height >= wdHeight ? 0 : (wdHeight - height)/2;

    if (top - redundant < 0 && top > height*-1) this.scrollTop(element, (top*-1 + redundant)*coefficient)
    else if (top - redundant >= 0) this.scrollTop(element, 0)
    else this.scrollTop(element, element.scrollHeight)
}

function scrollTop(element, scope) {
    element.scrollTo({top: scope, behavior: "smooth"})
}

function scrollHorizontal(element) {
    const $thisFirst = element.querySelector('.scrolling-text__list--1'),
        $thisSecond = element.querySelector('.scrolling-text__list--2');

    if (!$thisFirst) return;
  
    const top = element.getBoundingClientRect().top,
        height = element.getBoundingClientRect().height,
        wdHeight = window.innerHeight,
        scrollWidth = $thisFirst.scrollWidth > window.innerWidth ? $thisFirst.scrollWidth - window.innerWidth : 0,
        contentHeight = $thisFirst.getBoundingClientRect().height*2,
        redundant = height >= wdHeight ? 0 : (wdHeight - height)/2,
        coefficient = scrollWidth/(height/2 + redundant - contentHeight);
    
    let scope = (top*-1 + redundant)*coefficient,
        scope2 = (height/2 - contentHeight + redundant)*coefficient - scope;
    
    if (top - redundant < 0 && top - contentHeight > height*-1/2) {scope = scope*-1; scope2 = scope2*-1}
    else if (top - redundant >= 0) {scope = 0; scope2 = scrollWidth*-1}
    else {scope = scrollWidth*-1; scope2 = 0}
    $thisFirst.scrollWidth <= window.innerWidth ? $thisSecond.style.justifyContent = 'flex-end' : this.translateX($thisFirst, $thisSecond, scope, scope2);
}

function translateX($thisFirst, $thisSecond, scope, scope2) {
    $thisFirst.style.transform = `translateX(${scope}px)`;
    $thisSecond.style.transform = `translateX(${(scope2)}px)`;
}

class SmoothScrollMenu {
    constructor(selector) {
        this.menuItems = document.querySelectorAll(selector);
        this.attachEvents();
        this.hideMenuItemsWithoutSection();
    }

    attachEvents() {
        this.menuItems.forEach(item => {
            const anchor = item.querySelector('a');
            if (anchor && anchor.getAttribute('href') && anchor.getAttribute('href') !== "#") {
                anchor.addEventListener('click', event => this.handleMenuItemClick(event, anchor));
            }
        });
    }

    handleMenuItemClick(event, anchor) {
        event.preventDefault();

        var targetHref = anchor.getAttribute('href');
        var shouldScroll = true;
        const location = window.location.pathname + window.location.hash;

        if (targetHref.includes('/') && location !== targetHref) {
            window.location.href = targetHref;
            shouldScroll = false;
        }

        if (shouldScroll) {
            var targetElement = document.getElementById(anchor.getAttribute('href').split('#')[1]);
            if (targetElement) {
                this.scrollToSection(targetElement);
            }
        }
    }

    scrollToSection(element) {
        this.smoothScrollTo(element);
    }

    smoothScrollTo(element) {
        window.scrollTo({
            behavior: 'smooth',
            top: element.offsetTop
        });
    }

    hideMenuItemsWithoutSection() {
        this.menuItems.forEach(item => {
            const anchor = item.querySelector('a');
            const hash = anchor.getAttribute('href').split('#')[1];
            if (hash !== undefined && hash !== '' && !document.getElementById(hash)) {
                item.style.display = 'none';
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', function () {
    new SmoothScrollMenu('.header__inline-menu .menu-lv-1');
});
